export default __webpack_public_path__ + "static/media/Print_icon_disabled.037c68f6.svg";